
document.addEventListener("DOMContentLoaded", function () {
 
  // Function to add/remove sticky-header class based on scroll position
function handleScroll() {
    const mainHeader = document.querySelector(".main-header");

    if (mainHeader) { // Ensure the element exists
        // Check window width and scroll position
        if (window.innerWidth < 1080) {
            if (window.scrollY > 34) {
                mainHeader.classList.add("sticky-header");
            } else {
                mainHeader.classList.remove("sticky-header");
            }
        } else {
            // Ensure the class is removed if width exceeds 1080
            mainHeader.classList.remove("sticky-header");
        }
    }
}

  // Attach scroll and resize event listeners
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll); // Handle changes in window width
    handleScroll(); // Initial check on page load
});